import Swal from "sweetalert2";
import { fetchConToken } from "../../helpers/fetch";

// GET todos los tipos de membresía
export const getTiposMembresia = async () => {
    try {
        const resp = await fetchConToken('/api/dashboard/tipomembresia', {}, 'GET');
        const body = await resp.json();

        if (resp.ok) {
            return body.tiposMembresia;
        } else {
            Swal.fire('Error', body.msg || 'Error al obtener tipos de membresía', 'error');
            return [];
        }
    } catch (error) {
        console.log('Error fetching tipos de membresía:', error);
        Swal.fire('Error', 'Error al conectar con el servidor', 'error');
        return [];
    }
};

// PUT editar tipo de membresía
export const onEditarTipoMembresia = (id, max_auxiliares, max_clientes, descripcion = '', url_compra = '') => {
    return async (dispatch) => {
        try {
            const resp = await fetchConToken(
                `/api/dashboard/tipomembresia/${id}`,
                { max_auxiliares, max_clientes, descripcion, url_compra },
                'PUT'
            );
            const body = await resp.json();

            if (resp.ok) {
                Swal.fire({
                    icon: "success",
                    title: "Tipo de membresía actualizado correctamente",
                    showConfirmButton: false,
                    timer: 2000
                });
                return body.tipoMembresia;
            } else {
                Swal.fire('Error', body.msg || body.errors[0].msg, 'error');
                return null;
            }
        } catch (error) {
            console.log('Error editing tipo de membresía:', error);
            Swal.fire('Error', 'Error al actualizar tipo de membresía', 'error');
            return null;
        }
    }
};
